import dashboardApi from '@/services/API/dashboard'

// //Fetch customer based on a search string
// const fetchDeliveryTypes = function({ commit }) {
//   return deliveryTypeApi.fetchDeliveryTypes().then(deliveryTypes => {
//     commit('SET_DELIVERY_TYPES', deliveryTypes);
//   });
// };

const setDashboard = function({commit, dispatch, rootState}, dashboard){
  if(dashboard.name==="reservation-dashboard" || dashboard.name==="sales-order-dashboard"){
    dispatch('users/fetchAdminUsers',null,{root:true});
  }

  let clonedDashboard = _.cloneDeep(dashboard);

  if(dashboard.name==="sales-order-dashboard"){
    _.forEach(rootState.statuses.salesOrderStatuses, status=>{
      clonedDashboard.configuration.filters[status.code]=false;
    })
  }else if(dashboard.name==="invoice-dashboard"){
    _.forEach(rootState.statuses.invoiceStatuses, status=>{
      clonedDashboard.configuration.filters[status.code]=false;
    })

    clonedDashboard.configuration.fields =['inv_number','customer','due_date','amount','status'];

  }

  commit('SET_DASHBOARD_TO_ADD', clonedDashboard);
}

const setFiltersItem = function({commit}, {propName, value}){
  commit('SET_FILTERS_ITEM', {propName, value});
}

const setSalesReps = function({commit}, salesReps){
  commit('SET_SALES_REPS', salesReps);
}

const setCustomerClasses = function({commit}, customerClasses){
  commit('SET_CUSTOMER_CLASSES', customerClasses);
}

const setInventories = function({commit}, customerClasses){
  commit('SET_INVENTORIES', customerClasses);
}

const setProductId = function({commit}, productId){
  commit('SET_PRODUCT_ID', productId);
}

const setDashboardTitle = function({commit}, dashboardTitle){
  commit('SET_DASHBOARD_TITLE', dashboardTitle)
}

const setDashboardFields = function({commit}, fields){
  commit('SET_DASHBOARD_FIELDS', fields)
}

const post = function({commit, state, dispatch}){
  return dashboardApi.post(state.dashboardToAdd)
    .then(dashboard=>{
      dispatch('genericDashboards/addDashboard',dashboard,{root:true});
    })
}

const addCriteria = function({commit, state}, criteria){
  commit('ADD_CRITERIA',criteria )
}

const setOperatorOnCriteria = function({commit,state}, {id, operator}){
  let index = _.findIndex(state.dashboardToAdd.configuration.criterias, criteria=>{return criteria.id==id});
  commit('CHANGE_CRITERIA_OPERATOR', {index, operator});
}

const reset = function({commit}){
  commit('RESET');
}

const removeCriteria = function({commit, state}, id){
  let index = _.findIndex(state.dashboardToAdd.configuration.criterias, criteria=>{return criteria.id==id});
  commit('REMOVE_CRITERIA', index);
}

const setValueOnCriteria = function({commit, state}, {id, value}){
  let index = _.findIndex(state.dashboardToAdd.configuration.criterias, criteria=>{return criteria.id==id});
  commit('CHANGE_CRITERIA_VALUE', {index, value});
}

export default {
  setDashboard,
  setFiltersItem,
  setSalesReps,
  setDashboardTitle,
  post,
  reset,
  addCriteria,
  setOperatorOnCriteria,
  removeCriteria,
  setValueOnCriteria,
  setDashboardFields,
  setCustomerClasses,
  setProductId,
  setInventories
};
